import { defineElement, FC, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';

const BPDSvg: FC = () => {
    const [name] = useProp<string>('name', '');

    return (
        <svg class={`svg svg-${name}`}>
            <use xlinkHref={`#svg-${name}`}></use>
        </svg>
    );
};

BPDSvg.props = {
    name: { type: String },
};

defineElement('bpd-svg', BPDSvg);

export const BPDFunctionalSvg = ({
    name,
    attr = {},
}: {
    name: string;
    attr?: { [key: string]: any };
}) => (
    <svg class={`svg svg-${name}`} {...attr}>
        <use xlinkHref={`#svg-${name}`}></use>
    </svg>
);
